import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** e.g. 1536 -> "1.5 KB". Used anywhere we render videos.fileSizeBytes. */
export function formatBytes(bytes: number | undefined | null): string {
  if (!bytes || bytes <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, i);
  return `${value >= 10 || i === 0 ? Math.round(value) : value.toFixed(1)} ${units[i]}`;
}

/** YouTube/Vimeo link asset (zero-storage, no downloadable file). */
export function isLinkAsset(v?: { sourceType?: string | null } | null): boolean {
  const t = v?.sourceType ?? "upload";
  return t === "youtube" || t === "vimeo";
}
